import React, { useEffect, useState } from 'react'
import WeattherValue from '../../SystemValues/WeattherValue';
import TemperatureDetailContainer from '../../SystemValues/Temperature';
import OnlineStatusDetailContainer from '../../SystemValues/OnlineStatus';
import { calculateGlobalData } from '../../common/function';
import { weatherAwsApi } from '../../common/ApiCall';
import styles from '../../MainPage/common/styles';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'react-bootstrap-icons';

const WeatherSensors = ({ device, ppu, houseId, systemValuesComponent }) => {
  const navigate = useNavigate()
  const [selectedDeviceDetails, setSelectedDeviceDetails] = useState([]);
  const [systemValuesData, setSystemValuesData] = useState({
    globalMoneySaved: 0,
    globalMoneySpent: 0,
    globalUnitSaved: 0,
    globalUnitConsumed: 0,
    globalUnitSavingPercentge: 0,
    globalSaving: 0,
    time: "12:00 AM",
  });

  useEffect(() => {
    if (device) {
      const todayDateInStringWithoutHours = new Date().setHours(0, 0, 0, 0);
      weatherAwsApi(device.deviceId, todayDateInStringWithoutHours).then((res) => {
        setSelectedDeviceDetails([res])
      })
    }
  }, [])
  useEffect(() => {
    if (selectedDeviceDetails.length > 0) {
      const { systemValues, graphData, phaseLoadLogs } = calculateGlobalData(
        selectedDeviceDetails,
        ppu,
        device
      );

      let saving = []
      if (device?.graphParameters?.saving !== undefined && device?.graphParameters?.saving?.maximumUnitPerHour !== undefined) {
        for (let dataConsume of graphData.carbonConsumed) {
          saving.push(dataConsume)
        }
      }

      // setPhaseLoadLogs({ ...phaseLoadLogs });
      setSystemValuesData({ ...systemValues });
      // setGraphData({ ...graphData, saving });
    }
  }, [selectedDeviceDetails])
  const systemValuesWeaherContainerComponents = {
    onlineStatus: (
      <OnlineStatusDetailContainer
        key="onlineStatus"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceDetails}
      />
    ),
    temperature: (
      <TemperatureDetailContainer
        key="temperature"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceDetails}
      />
    ),
    Humidity: (
      <WeattherValue
        key="Humidity"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceDetails}
        stacked="true"
        dataKey={"humidityLogs"}
        valueKey={"h"}
        name={"Humidity"}
        timeKey={"ts"}
        degree={' AH'}
      />
    ),
  };
  return (
    <div style={{
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
      padding: "20px",
      marginTop: "20px",
      borderRadius: "10px",
      backgroundColor: 'rgb(243 244 244)',
      position: 'relative'
    }}>
      <ChevronRight
        style={{ position: 'absolute', right: '20px', top: '20px', fontSize: '20px', fontWeight: '800' }}
        onClick={() => navigate(`/dashboard/${device.type}/${houseId}/${device.roomId}/${device.deviceId}`)}
      />
      <div>
        <h5 style={{ textAlign: 'left' }}> {device?.name ? `${device?.name} - ` : ""}
          {device.deviceId}
        </h5>
      </div>
      <Row style={{ ...styles.smallBoxContainer }} className="row g-2">
        {Object.keys(systemValuesWeaherContainerComponents).filter(value => systemValuesComponent.includes(value)).map((key) =>
          <Col md={6} sm={12} key={key}>
            {React.cloneElement(systemValuesWeaherContainerComponents[key], { key: `${key}-${device?.deviceId}` })}
          </Col>
        )}
      </Row>
    </div>
  )
}

export default WeatherSensors